document.addEventListener('DOMContentLoaded', function () {
  /* Mobile nav toggle */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var mobileNav = document.querySelector('[data-mobile-nav]');
  var navClose = document.querySelector('[data-nav-close]');

  function openNav() {
    if (mobileNav) mobileNav.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (mobileNav) mobileNav.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  if (navToggle) navToggle.addEventListener('click', openNav);
  if (navClose) navClose.addEventListener('click', closeNav);
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });
  }

  /* Scroll fade-in animations */
  var animated = document.querySelectorAll('[data-animate]');
  if ('IntersectionObserver' in window && animated.length) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    animated.forEach(function (el) { observer.observe(el); });
  } else {
    animated.forEach(function (el) { el.classList.add('in-view'); });
  }

  /* Header shadow on scroll */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 8px 24px -18px rgba(0,0,0,.6)';
      } else {
        header.style.boxShadow = 'none';
      }
    });
  }
});
